function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 7.57941,
  y: 5.34576,
  width: 107.714,
  height: 229.472,
  rx: 4.656,
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M103.385 240H37.1015V230.327H103.385C107.483 230.327 110.311 229.482 112.031 227.744C115.711 224.026 115.644 215.217 115.567 205.025C115.554 203.507 115.544 201.965 115.544 200.392V39.605C115.544 17.518 113.278 9.67313 100.556 9.67313H24.1354C11.6418 9.67313 9.6426 16.7797 9.6426 39.605V207.74H0V39.605C0 21.958 0 0 24.1354 0H100.556C125.187 0 125.187 22.8931 125.187 39.605V200.392C125.187 201.936 125.196 203.458 125.209 204.948C125.302 217.304 125.383 227.98 118.874 234.557C115.252 238.22 110.186 240 103.385 240Z",
  fill: "#C7C7C7"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M21.8465 240H88.1297V230.327H21.8465C17.7484 230.327 14.9199 229.482 13.2003 227.744C9.52005 224.026 9.58755 215.217 9.66469 205.025C9.67754 203.507 9.68719 201.965 9.68719 200.392V39.605C9.68719 17.518 11.9532 9.67313 24.675 9.67313H101.096C113.589 9.67313 115.589 16.7797 115.589 39.605V207.74H125.231V39.605C125.231 21.958 125.231 0 101.096 0H24.675C0.0445862 0 0.0445862 22.8931 0.0445862 39.605V200.392C0.0445862 201.936 0.0349503 203.458 0.0220947 204.948C-0.0711136 217.304 -0.151482 227.98 6.35728 234.557C9.97968 238.22 15.0453 240 21.8465 240Z",
  fill: "#C7C7C7"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M88.1273 11.3401C88.1273 14.9353 83.7785 17.8469 78.4172 17.8469H48.1748C42.8135 17.8469 38.4647 14.9385 38.4647 11.3401C38.4679 7.74816 42.8167 4.83655 48.178 4.83655H78.4204C83.7784 4.83655 88.1273 7.74816 88.1273 11.3401Z",
  fill: "#C7C7C7"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.3
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.0926 96.0723H60.1146V127.082H26.0926V96.0723Z",
  fill: "#C7C7C7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.0925 136.385H38.4641V144.138H26.0925V136.385Z",
  fill: "#C7C7C7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.6496 136.385H58.5677V144.138H44.6496V136.385Z",
  fill: "#C7C7C7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.0925 153.44H60.1145V161.193H26.0925V153.44Z",
  fill: "#C7C7C7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64.7541 96.0723H98.7762V127.082H64.7541V96.0723Z",
  fill: "#C7C7C7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64.7541 136.385H77.1258V144.138H64.7541V136.385Z",
  fill: "#C7C7C7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M84.8577 136.385H98.7758V144.138H84.8577V136.385Z",
  fill: "#C7C7C7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64.7541 153.44H98.7762V161.193H64.7541V153.44Z",
  fill: "#C7C7C7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.0925 173.597H100.322V192.203H26.0925V173.597Z",
  fill: "#C7C7C7"
}));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M105.877 53.4972C106.53 53.4972 107.064 52.9562 107.064 52.2948V42.0745C107.064 41.4132 106.53 40.8721 105.877 40.8721C105.224 40.8721 104.69 41.4132 104.69 42.0745V52.2948C104.69 52.9562 105.224 53.4972 105.877 53.4972Z",
  fill: "url(#paint0_linear)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M123.685 58.6825H115.375C114.722 58.6825 114.187 59.2236 114.187 59.8849C114.187 60.5462 114.722 61.0873 115.375 61.0873H123.685C124.338 61.0873 124.872 60.5462 124.872 59.8849C124.872 59.2236 124.338 58.6825 123.685 58.6825Z",
  fill: "url(#paint1_linear)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M118.728 48.4772C119.203 47.9963 119.203 47.2448 118.728 46.7638C118.253 46.2829 117.511 46.2829 117.036 46.7638L110.061 53.8279C109.586 54.3088 109.586 55.0603 110.061 55.5413C110.299 55.7817 110.595 55.902 110.892 55.902C111.189 55.902 111.486 55.7817 111.723 55.5413L118.728 48.4772Z",
  fill: "url(#paint2_linear)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M210.763 122.197C217.358 122.197 222.704 116.847 222.704 110.25C222.704 103.652 217.358 98.3037 210.763 98.3037C204.17 98.3037 198.826 103.652 198.826 110.25C198.826 116.847 204.17 122.197 210.763 122.197ZM208.33 113.904C208.961 114.129 209.614 114.277 210.288 114.349V115.697H211.707V114.376C212.19 114.331 212.628 114.236 213.022 114.093C213.42 113.949 213.758 113.756 214.041 113.514C214.322 113.272 214.541 112.986 214.695 112.659C214.851 112.331 214.927 111.96 214.927 111.547V111.519C214.927 111.107 214.86 110.742 214.723 110.428C214.587 110.114 214.381 109.842 214.109 109.613C213.836 109.384 213.498 109.186 213.092 109.02C212.687 108.854 212.211 108.709 211.666 108.582V107.019C211.976 107.092 212.286 107.194 212.601 107.329C212.915 107.464 213.212 107.63 213.493 107.828L214.614 106.023C214.204 105.744 213.764 105.515 213.289 105.336C212.816 105.155 212.299 105.034 211.734 104.972V104.163H210.315V104.931C209.797 104.967 209.333 105.061 208.929 105.214C208.525 105.367 208.183 105.566 207.907 105.814C207.628 106.061 207.418 106.35 207.271 106.683C207.125 107.015 207.053 107.379 207.053 107.773V107.802C207.053 108.223 207.124 108.587 207.265 108.892C207.406 109.198 207.615 109.465 207.893 109.695C208.171 109.923 208.515 110.118 208.929 110.28C209.342 110.441 209.823 110.585 210.37 110.712V112.328C209.942 112.256 209.521 112.131 209.107 111.951C208.692 111.772 208.267 111.529 207.83 111.223L206.602 113.016C207.121 113.384 207.697 113.68 208.33 113.904ZM212.015 112.155C212.645 112.089 212.963 111.852 212.963 111.442V111.415C212.963 111.228 212.895 111.075 212.764 110.954C212.631 110.833 212.383 110.722 212.015 110.619V112.155ZM210.037 107.111C209.689 107.138 209.441 107.215 209.295 107.341C209.149 107.465 209.076 107.622 209.076 107.808V107.836C209.076 108.023 209.139 108.173 209.266 108.289C209.394 108.405 209.651 108.514 210.037 108.617V107.111Z",
  fill: "#FFCF40"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M210.763 120.206C216.259 120.206 220.714 115.748 220.714 110.25C220.714 104.752 216.259 100.295 210.763 100.295C205.268 100.295 200.815 104.752 200.815 110.25C200.815 115.748 205.268 120.206 210.763 120.206ZM208.33 113.904C208.961 114.128 209.614 114.277 210.288 114.349V115.697H211.707V114.376C212.19 114.331 212.628 114.236 213.023 114.093C213.42 113.949 213.759 113.756 214.042 113.514C214.322 113.272 214.542 112.986 214.695 112.659C214.851 112.33 214.928 111.96 214.928 111.546V111.519C214.928 111.107 214.86 110.742 214.724 110.428C214.587 110.114 214.381 109.842 214.109 109.613C213.836 109.384 213.498 109.186 213.093 109.02C212.687 108.854 212.212 108.709 211.666 108.582V107.019C211.976 107.092 212.286 107.194 212.601 107.329C212.915 107.464 213.212 107.63 213.494 107.828L214.614 106.023C214.204 105.744 213.764 105.515 213.289 105.336C212.816 105.155 212.299 105.034 211.734 104.972V104.163H210.315V104.931C209.797 104.967 209.333 105.061 208.93 105.214C208.526 105.367 208.184 105.566 207.907 105.814C207.628 106.061 207.419 106.35 207.271 106.683C207.125 107.015 207.053 107.379 207.053 107.773V107.802C207.053 108.223 207.124 108.587 207.265 108.892C207.406 109.198 207.616 109.465 207.893 109.695C208.171 109.923 208.516 110.118 208.93 110.28C209.343 110.441 209.824 110.585 210.37 110.712V112.328C209.942 112.255 209.522 112.131 209.108 111.95C208.692 111.772 208.267 111.529 207.83 111.222L206.602 113.016C207.122 113.384 207.697 113.68 208.33 113.904ZM212.015 112.155C212.646 112.089 212.963 111.852 212.963 111.442V111.415C212.963 111.228 212.895 111.075 212.765 110.954C212.631 110.833 212.384 110.721 212.015 110.619V112.155ZM210.037 107.111C209.689 107.138 209.441 107.215 209.295 107.341C209.149 107.465 209.076 107.622 209.076 107.808V107.836C209.076 108.023 209.14 108.173 209.266 108.289C209.395 108.405 209.652 108.514 210.037 108.617V107.111Z",
  fill: "#F5A623"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 147.969,
  y: 83.5782,
  width: 56.3703,
  height: 31.2915,
  fill: "#F1F2F3"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M147.968 113.05H154.095V84.8055H147.968V113.05Z",
  fill: "#DDDDDD"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M147.357 83.5782V84.9564C147.357 85.8867 147.958 86.646 148.695 86.646H153.339C154.077 86.646 154.678 85.8867 154.678 84.9564V83.5782H147.357Z",
  fill: "#B7B7B3"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M147.356 114.363H154.677V112.416H147.356V114.363Z",
  fill: "#B7B7B3"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M160.224 113.05H166.351V84.8055H160.224V113.05Z",
  fill: "#DDDDDD"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M159.611 83.5782V84.9564C159.611 85.8867 160.213 86.646 160.953 86.646H165.639C166.378 86.646 166.982 85.8867 166.982 84.9564V83.5782H159.611Z",
  fill: "#B7B7B3"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M159.611 114.363H166.982V112.416H159.611V114.363Z",
  fill: "#B7B7B3"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M173.091 113.05H179.218V84.8055H173.091V113.05Z",
  fill: "#DDDDDD"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M172.479 83.5782V84.9564C172.479 85.8867 173.082 86.646 173.822 86.646H178.508C179.247 86.646 179.851 85.8867 179.851 84.9564V83.5782H172.479Z",
  fill: "#B7B7B3"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M172.479 114.363H179.85V112.416H172.479V114.363Z",
  fill: "#B7B7B3"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M185.344 113.05H191.472V84.8055H185.344V113.05Z",
  fill: "#DDDDDD"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M184.733 83.5782V84.9564C184.733 85.8867 185.335 86.646 186.076 86.646H190.762C191.501 86.646 192.104 85.8867 192.104 84.9564V83.5782H184.733Z",
  fill: "#B7B7B3"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M184.732 114.363H192.053V112.416H184.732V114.363Z",
  fill: "#B7B7B3"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M198.212 113.05H204.34V84.8055H198.212V113.05Z",
  fill: "#DDDDDD"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M197.601 83.5782V84.9564C197.601 85.8867 198.203 86.646 198.944 86.646H203.63C204.369 86.646 204.972 85.8867 204.972 84.9564V83.5782H197.601Z",
  fill: "#B7B7B3"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M197.6 114.363H204.921V112.416H197.6V114.363Z",
  fill: "#B7B7B3"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M212.931 80.0716L176.066 61.0821L139.2 80.0716H139.107V80.1184L139.096 80.1244H139.107V83.8302H213.041V80.0716H212.931Z",
  fill: "#DDDDDD"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M150.581 78.8894L175.874 65.9427L201.165 78.8894H150.581Z",
  fill: "#FFFEFD"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M143.906 118.274H208.224V114.515H143.906V118.274Z",
  fill: "#DDDDDD"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M140.601 121.864H211.529V118.105H140.601V121.864Z",
  fill: "#B7B7B3"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M164.826 77.2007C164.774 77.2007 164.728 77.1814 164.69 77.1428C164.652 77.1042 164.633 77.0584 164.633 77.0053V72.33C164.633 72.277 164.652 72.2311 164.69 72.1925C164.728 72.1539 164.774 72.1346 164.826 72.1346H167.133C167.452 72.1346 167.722 72.1793 167.942 72.2685C168.162 72.3578 168.337 72.4736 168.468 72.6159C168.6 72.7583 168.694 72.9199 168.751 73.1008C168.809 73.2818 168.837 73.4615 168.837 73.64C168.837 73.7799 168.822 73.9017 168.791 74.0055C168.76 74.1092 168.723 74.1985 168.68 74.2733C168.637 74.348 168.593 74.4084 168.547 74.4542C168.502 74.5 168.465 74.535 168.436 74.5591C168.622 74.6894 168.753 74.8402 168.827 75.0115C168.901 75.1827 168.938 75.389 168.938 75.6302C168.938 75.8281 168.909 76.0211 168.852 76.2092C168.794 76.3974 168.7 76.5651 168.569 76.7122C168.437 76.8594 168.267 76.9776 168.057 77.0668C167.846 77.1561 167.589 77.2007 167.283 77.2007H164.826ZM167.504 73.6689C167.504 73.5435 167.467 73.4434 167.393 73.3686C167.319 73.2938 167.211 73.2564 167.067 73.2564H165.957V74.0814H167.067C167.211 74.0814 167.319 74.044 167.393 73.9693C167.467 73.8945 167.504 73.7944 167.504 73.6689ZM165.957 76.0789H167.139C167.282 76.0789 167.397 76.0367 167.483 75.9523C167.569 75.8678 167.612 75.7629 167.612 75.6374C167.612 75.512 167.569 75.4071 167.483 75.3226C167.397 75.2382 167.282 75.196 167.139 75.196H165.957V76.0789ZM172.864 72.1348C172.96 72.1348 173.033 72.1613 173.083 72.2144C173.133 72.2675 173.168 72.3205 173.187 72.3736L174.748 76.9331C174.767 76.9813 174.777 77.0175 174.777 77.0416C174.777 77.0851 174.761 77.1225 174.73 77.1538C174.699 77.1852 174.662 77.2009 174.619 77.2009H173.717C173.621 77.2009 173.553 77.1804 173.513 77.1393C173.472 77.0983 173.447 77.0585 173.437 77.0199L173.237 76.4192H171.331L171.131 77.0199C171.121 77.0585 171.096 77.0983 171.056 77.1393C171.015 77.1804 170.947 77.2009 170.852 77.2009H169.949C169.906 77.2009 169.869 77.1852 169.838 77.1538C169.807 77.1225 169.791 77.0851 169.791 77.0416C169.791 77.0175 169.801 76.9813 169.82 76.9331L171.382 72.3736C171.401 72.3205 171.435 72.2675 171.485 72.2144C171.536 72.1613 171.608 72.1348 171.704 72.1348H172.864ZM171.704 75.2973H172.864L172.284 73.5604L171.704 75.2973ZM179.197 77.2009C179.116 77.2009 179.051 77.1791 179 77.1357C178.95 77.0923 178.918 77.0585 178.904 77.0344L177.263 74.5593V77.0055C177.263 77.0585 177.244 77.1044 177.206 77.143C177.168 77.1816 177.123 77.2009 177.07 77.2009H176.132C176.079 77.2009 176.034 77.1816 175.996 77.143C175.957 77.1044 175.938 77.0585 175.938 77.0055V72.3302C175.938 72.2771 175.957 72.2313 175.996 72.1927C176.034 72.1541 176.079 72.1348 176.132 72.1348H176.877C176.958 72.1348 177.023 72.1565 177.074 72.1999C177.124 72.2433 177.156 72.2771 177.17 72.3012L178.811 74.7764V72.3302C178.811 72.2771 178.83 72.2313 178.868 72.1927C178.906 72.1541 178.951 72.1348 179.004 72.1348H179.942C179.995 72.1348 180.04 72.1541 180.078 72.1927C180.117 72.2313 180.136 72.2771 180.136 72.3302V77.0055C180.136 77.0585 180.117 77.1044 180.078 77.143C180.04 77.1816 179.995 77.2009 179.942 77.2009H179.197ZM185.968 76.962C185.982 76.9813 185.989 77.0079 185.989 77.0416C185.989 77.0851 185.974 77.1225 185.943 77.1538C185.912 77.1852 185.875 77.2009 185.832 77.2009H184.693C184.626 77.2009 184.571 77.1864 184.528 77.1574C184.485 77.1285 184.442 77.0875 184.399 77.0344L183.046 75.3119V77.0055C183.046 77.0585 183.026 77.1044 182.988 77.143C182.95 77.1816 182.905 77.2009 182.852 77.2009H181.914C181.861 77.2009 181.816 77.1816 181.778 77.143C181.74 77.1044 181.72 77.0585 181.72 77.0055V72.3302C181.72 72.2771 181.74 72.2313 181.778 72.1927C181.816 72.1541 181.861 72.1348 181.914 72.1348H182.852C182.905 72.1348 182.95 72.1541 182.988 72.1927C183.026 72.2313 183.046 72.2771 183.046 72.3302V73.8572L184.306 72.294C184.33 72.265 184.361 72.2313 184.399 72.1927C184.438 72.1541 184.502 72.1348 184.593 72.1348H185.71C185.753 72.1348 185.79 72.1505 185.821 72.1818C185.852 72.2132 185.868 72.2506 185.868 72.294C185.868 72.3278 185.861 72.3543 185.846 72.3736L184.077 74.5593L185.968 76.962Z",
  fill: "#949494"
});

var _ref33 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_i)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 21.2858,
  height: 2.53477,
  rx: 0.370203,
  transform: "matrix(-1 0 0 1 154.651 119.542)",
  fill: "#FFCF40"
}));

var _ref34 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_i)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 21.2857,
  height: 2.53477,
  rx: 0.370203,
  transform: "matrix(-1 0 0 1 152.623 117.007)",
  fill: "#FFCF40"
}));

var _ref35 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_i)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 21.2857,
  height: 2.53477,
  rx: 0.370203,
  transform: "matrix(-1 0 0 1 154.144 114.472)",
  fill: "#FFCF40"
}));

var _ref36 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter3_i)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 21.2858,
  height: 2.53477,
  rx: 0.370203,
  transform: "matrix(-1 0 0 1 154.651 111.937)",
  fill: "#FFCF40"
}));

var _ref37 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter4_i)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 21.2858,
  height: 2.53477,
  rx: 0.370203,
  transform: "matrix(-1 0 0 1 155.934 109.375)",
  fill: "#FFCF40"
}));

var _ref38 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter5_i)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 21.2857,
  height: 2.53477,
  rx: 0.370203,
  transform: "matrix(-1 0 0 1 155.292 106.812)",
  fill: "#FFCF40"
}));

var _ref39 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter6_d)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M93.2693 132.238H142.295V193.149H96.3913C94.6671 193.149 93.2693 191.751 93.2693 190.027V132.238Z",
  fill: "#F1F2F3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M142.294 184.235H146.751V191.275C146.751 192.31 145.912 193.149 144.878 193.149H142.294V184.235Z",
  fill: "#C4C4C4"
}), /*#__PURE__*/React.createElement("rect", {
  x: 100.697,
  y: 163.436,
  width: 35.655,
  height: 2.97125,
  rx: 1.48563,
  fill: "#C4C4C4"
}), /*#__PURE__*/React.createElement("rect", {
  x: 100.697,
  y: 169.379,
  width: 35.655,
  height: 2.97125,
  rx: 1.48563,
  fill: "#C4C4C4"
}), /*#__PURE__*/React.createElement("rect", {
  x: 100.697,
  y: 153.037,
  width: 22.2844,
  height: 2.97124,
  rx: 1.48562,
  fill: "#C4C4C4"
}), /*#__PURE__*/React.createElement("rect", {
  x: 100.697,
  y: 175.321,
  width: 22.2844,
  height: 2.97125,
  rx: 1.48563,
  fill: "#C4C4C4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M142.295 193.149V188.692C142.295 188.693 142.295 192.406 145.266 192.406C145.266 192.406 144.719 193.149 143.037 193.149H142.295Z",
  fill: "#F1F2F3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M102.355 148.481C102.288 148.481 102.227 148.457 102.172 148.41C102.125 148.356 102.101 148.295 102.101 148.227V141.628C102.101 141.554 102.125 141.493 102.172 141.446C102.227 141.398 102.288 141.375 102.355 141.375H105.451C106.304 141.375 106.937 141.551 107.35 141.902C107.769 142.248 107.979 142.742 107.979 143.385C107.979 143.723 107.891 144.011 107.715 144.248C107.546 144.478 107.353 144.647 107.137 144.755C107.414 144.884 107.648 145.09 107.837 145.374C108.027 145.659 108.121 145.977 108.121 146.329C108.121 147.005 107.898 147.533 107.451 147.912C107.005 148.291 106.369 148.481 105.543 148.481H102.355ZM105.248 144.197C105.519 144.197 105.726 144.129 105.868 143.994C106.01 143.852 106.081 143.665 106.081 143.435C106.081 143.212 106.01 143.033 105.868 142.897C105.726 142.762 105.519 142.694 105.248 142.694H103.929V144.197H105.248ZM105.34 147.161C105.617 147.161 105.834 147.08 105.99 146.917C106.145 146.755 106.223 146.559 106.223 146.329C106.223 146.085 106.145 145.885 105.99 145.73C105.834 145.567 105.617 145.486 105.34 145.486H103.929V147.161H105.34Z",
  fill: "#949494"
}), /*#__PURE__*/React.createElement("path", {
  d: "M110.518 148.481C110.451 148.481 110.39 148.457 110.336 148.41C110.288 148.356 110.264 148.295 110.264 148.227V141.628C110.264 141.554 110.288 141.493 110.336 141.446C110.39 141.398 110.451 141.375 110.518 141.375H111.879C111.953 141.375 112.014 141.398 112.061 141.446C112.115 141.493 112.143 141.554 112.143 141.628V148.227C112.143 148.301 112.115 148.362 112.061 148.41C112.014 148.457 111.953 148.481 111.879 148.481H110.518Z",
  fill: "#949494"
}), /*#__PURE__*/React.createElement("path", {
  d: "M114.5 148.481C114.426 148.481 114.365 148.457 114.317 148.41C114.27 148.356 114.246 148.291 114.246 148.217V147.232C114.246 147.09 114.297 146.968 114.398 146.867L117.667 142.887H114.591C114.524 142.887 114.463 142.863 114.409 142.816C114.361 142.762 114.338 142.701 114.338 142.633V141.628C114.338 141.554 114.361 141.493 114.409 141.446C114.463 141.398 114.524 141.375 114.591 141.375H119.718C119.792 141.375 119.853 141.398 119.901 141.446C119.948 141.493 119.972 141.554 119.972 141.628V142.613C119.972 142.728 119.928 142.843 119.84 142.958L116.662 146.948H119.83C119.904 146.948 119.965 146.975 120.012 147.029C120.067 147.076 120.094 147.137 120.094 147.212V148.227C120.094 148.301 120.067 148.362 120.012 148.41C119.965 148.457 119.904 148.481 119.83 148.481H114.5Z",
  fill: "#949494"
}));

var _ref40 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.2873 62.9556C27.5516 60.5132 27.7087 58.792 27.7087 58.792C27.7087 58.792 28.2658 54.1963 32.2547 54.1963L32.444 54.1999C32.5763 54.1995 32.7086 54.2054 32.8403 54.2177V54.2106C32.8403 54.2106 35.4829 54.332 36.1007 56.5924C36.0186 57.3672 35.1258 58.1957 34.8401 58.2421C33.451 57.7422 32.8225 57.2066 32.8225 57.2066L32.8296 55.6175C32.1476 55.3461 31.4369 55.5068 31.2655 57.1673C31.1846 58.8168 31.087 60.4654 30.9727 62.1129C33.2403 62.0236 34.6687 62.7557 34.6687 62.7557L34.5973 63.8126C33.4903 63.477 32.169 63.5163 30.8548 63.7412C30.0871 73.6039 29.0693 76.7106 29.0693 76.7106C29.0693 76.7106 27.7587 81.542 23.5949 81.3991C21.1237 81.3991 20.938 79.4959 20.938 79.4959L21.7951 78.9245C21.7951 78.9245 23.1878 82.2204 24.7233 78.5032C25.6304 76.2964 26.5124 69.7617 27.0802 64.8161C25.5197 65.4052 24.4198 65.9837 24.4198 65.9837L23.9341 64.9696C24.9542 64.1476 26.0825 63.4699 27.2873 62.9556ZM72.7819 62.4128C72.7819 61.0916 73.7926 60.0204 75.0424 60.0204L102.429 60.0204C103.675 60.0204 104.689 61.0952 104.689 62.4164V76.8427C104.689 78.1639 103.679 79.2352 102.429 79.2352H75.0424C73.7961 79.2352 72.7819 78.1603 72.7819 76.8391V62.4128ZM99.3875 64.6768H101.269L97.7841 70.3902V74.5788H96.1057V70.3831L92.6489 64.6733H94.6273L97.0021 68.8226L99.3875 64.6733V64.6768ZM89.3874 64.6769H87.4483L83.5951 74.5789H85.3699L86.2877 72.0936H90.4766L91.4122 74.5789H93.2406L89.3874 64.6769ZM77.3428 64.6769H81.0103C82.9101 64.6769 84.1671 65.9624 84.1671 67.6943C84.1671 69.4404 82.9101 70.7081 81.0103 70.7081H79.0176V74.5789H77.3392V64.6769H77.3428ZM58.2055 71.7328C58.2055 69.1832 58.9269 67.1728 60.3696 65.6945V65.6909C61.8123 64.2162 63.4479 63.477 65.2834 63.477C66.4083 63.477 67.3367 63.7734 68.0617 64.3626C68.7799 64.9357 69.184 65.8153 69.1508 66.7336C69.1508 67.7227 68.9151 68.5512 68.4473 69.2261C67.9795 69.8974 67.4117 70.4187 66.7439 70.783C65.3869 71.4971 64.1442 71.9471 63.0193 72.1292L62.3301 72.222C62.4658 74.1396 63.2015 75.0966 64.537 75.0966C65.0452 75.0843 65.5442 74.9587 65.9976 74.7288C66.4297 74.5376 66.8354 74.2916 67.2046 73.9967L67.6331 73.6289L68.3188 74.6074C68.1652 74.8323 67.8617 75.1251 67.401 75.4929C66.9439 75.8607 66.5154 76.1678 66.1119 76.4106C65.0118 77.0622 63.755 77.4017 62.4765 77.3926C61.1552 77.3926 60.1161 76.8927 59.3519 75.8929C58.5876 74.893 58.2055 73.5075 58.2055 71.7328ZM62.8903 67.0407C63.2831 65.723 63.8402 65.066 64.5687 65.066C65.1758 65.066 65.4829 65.6195 65.4829 66.7193C65.4829 67.8191 65.1972 68.719 64.6258 69.4082C64.0509 70.1009 63.276 70.5401 62.3046 70.7222C62.3046 69.5796 62.4975 68.3548 62.8903 67.0407ZM54.1384 65.3731C54.4634 64.659 54.7705 64.159 55.0562 63.8734L55.4561 63.477C56.2775 63.477 56.8988 63.7127 57.3166 64.1805C57.731 64.6305 57.9571 65.2221 57.9487 65.8338C57.9487 67.4407 57.5773 69.144 56.831 70.9401C56.0882 72.7327 55.0954 74.2574 53.8527 75.5108C52.61 76.7642 51.3494 77.3891 50.071 77.3891C49.2675 77.3891 48.6497 77.1248 48.2212 76.5963C47.7926 76.0643 47.5784 75.368 47.5784 74.5002C47.5934 73.3306 47.6553 72.1619 47.7641 70.9972C47.889 69.5296 47.9498 68.0727 47.9498 66.6265C47.9283 66.22 47.8161 65.8234 47.6212 65.466C47.3998 65.016 47.1784 64.659 46.9463 64.3947L47.032 64.0269C48.064 63.6591 48.9961 63.477 49.8281 63.477C50.6566 63.477 51.278 63.6591 51.6887 64.0269C52.0993 64.3947 52.3064 65.1482 52.3064 66.2873C52.3064 66.9015 52.1315 68.1513 51.7886 70.0367C51.4458 71.9221 51.2744 73.0683 51.2744 73.4754C51.2744 74.2931 51.428 74.7002 51.7315 74.7002C52.4564 74.7002 53.2563 74.1217 54.1241 72.9719C54.9919 71.8185 55.449 70.858 55.4847 70.0795L53.5349 67.7585C53.6135 66.88 53.8134 66.0873 54.1384 65.3731ZM34.9156 65.848C33.8657 67.4264 33.3407 69.5832 33.3407 72.3113C33.3407 74.0682 33.68 75.3501 34.3585 76.1678C35.037 76.982 35.8655 77.3891 36.8475 77.3891C37.8331 77.3891 38.9366 76.8177 40.1579 75.6751C40.3471 76.8177 41.0363 77.3891 42.2219 77.3891C42.829 77.3891 43.5182 77.182 44.2824 76.7642C45.0466 76.3464 45.568 76.0143 45.843 75.7679C46.1215 75.5251 46.3465 75.3215 46.5179 75.1608L46.0037 74.0896L45.6573 74.2681C44.9324 74.6609 44.5146 74.8502 44.3967 74.8502C44.2467 74.8502 44.1682 74.4574 44.1682 73.6718C44.1682 72.8898 44.311 71.5757 44.5967 69.7296C44.8824 67.887 45.2681 66.1159 45.743 64.4233C44.236 63.8519 43.0326 63.5663 42.1362 63.5663C42.0538 63.8405 41.9475 64.107 41.8184 64.3626C40.8881 63.7897 39.8184 63.4834 38.7259 63.477C37.2367 63.477 35.9654 64.2662 34.9156 65.848ZM38.2219 67.437C37.7362 68.8725 37.4934 70.458 37.4934 72.1898C37.4934 73.9253 37.8469 74.7894 38.554 74.7894C39.0111 74.7894 39.5289 74.5966 40.1002 74.2109C40.2359 71.3364 40.6823 68.4904 41.4501 65.6802C40.8752 65.4124 40.3859 65.2802 39.986 65.2802C39.2968 65.2802 38.7111 65.998 38.2219 67.437ZM79.0175 66.1588V69.2297H80.7602C81.8208 69.2297 82.4636 68.6441 82.4636 67.7085C82.4636 66.7587 81.8208 66.1588 80.7602 66.1588H79.0175ZM89.8917 70.5438H86.8742L88.3847 66.4945L89.8917 70.5438Z",
  fill: "#DE206A"
});

var _ref41 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_i",
  x: 133.365,
  y: 119.542,
  width: 21.2858,
  height: 2.53477,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -0.787941
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.960784 0 0 0 0 0.65098 0 0 0 0 0.137255 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_i",
  x: 131.337,
  y: 117.007,
  width: 21.2857,
  height: 2.53477,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -0.787941
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.960784 0 0 0 0 0.65098 0 0 0 0 0.137255 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_i",
  x: 132.858,
  y: 114.472,
  width: 21.2857,
  height: 2.53477,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -0.787941
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.960784 0 0 0 0 0.65098 0 0 0 0 0.137255 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter3_i",
  x: 133.365,
  y: 111.937,
  width: 21.2858,
  height: 2.53477,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -0.787941
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.960784 0 0 0 0 0.65098 0 0 0 0 0.137255 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter4_i",
  x: 134.648,
  y: 109.375,
  width: 21.2858,
  height: 2.53477,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -0.787941
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.960784 0 0 0 0 0.65098 0 0 0 0 0.137255 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter5_i",
  x: 134.006,
  y: 106.812,
  width: 21.2857,
  height: 2.53477,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -0.787941
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.960784 0 0 0 0 0.65098 0 0 0 0 0.137255 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter6_d",
  x: 89.2693,
  y: 130.238,
  width: 61.4816,
  height: 68.9107,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 104.739,
  y1: 40.8721,
  x2: 104.739,
  y2: 53.4972,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF2E95"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5858"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 124.872,
  y1: 57.4801,
  x2: 114.187,
  y2: 57.4801,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF2E95"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5858"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 109.9,
  y1: 46.4031,
  x2: 109.9,
  y2: 55.902,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF2E95"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5858"
})));

var SvgImgFavepayStep1 = function SvgImgFavepayStep1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 223,
    height: 240,
    viewBox: "0 0 223 240",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImgFavepayStep1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/img-favepay-step-1.99f7337c.svg";
export { ForwardRef as ReactComponent };